import { MagnifyingGlass } from 'phosphor-react';
import React, { useRef, useCallback } from "react";

// import style
import './SearchBar.css';

const SearchBar =({ id, onChange, initialValue }) => {
  const inputRef = useRef(null);

  // Memoize the onChange handler to prevent it from being recreated on every render
  const handleOnChange = useCallback(
    (e) => {
      if (onChange) {
        onChange(e.target.value);
      }
    },
    [onChange]
  );

  return (
    <section className="search_bar_container">
      <input autoComplete='off' type='text' placeholder="Search products" id={id} onChange={handleOnChange} 
      value={initialValue} ref={inputRef}/>
      <MagnifyingGlass className="dashboard_navigation_icon mues_grey_II" weight="bold"/>
    </section>
  );
};

export default SearchBar;